import { render, staticRenderFns } from "./FormProduct.vue?vue&type=template&id=7d23cbab&scoped=true"
import script from "./FormProduct.vue?vue&type=script&lang=js"
export * from "./FormProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d23cbab",
  null
  
)

export default component.exports